import {registerCustomHook} from "../lib/core";
import {store} from "../lib/store";
import {CONFIG} from "./config";

//Custom loading hooks
export const initCustomHooks = () => {
	//registerCustomHook('onNotFoundLoadingPage', (params) => {});
	//registerCustomHook('onBeforeEvaluatingPage', (params) => {});

    registerCustomHook('onBeforeLoadingPage', (params) => {


        if (CONFIG.cachePages > 0 && store.getState().pageState.previous.map(prev => prev.page?.slug).indexOf(params.search) >= 0) {
            let index = store.getState().pageState.previous.map(prev => prev.page?.slug).indexOf(params.search);
            store.dispatch({
                type: 'PAGE_LOADED',
                page: store.getState().pageState.previous[index].page,
                head: store.getState().pageState.previous[index].head
            })
            return false;
        }
        return true;

    });

	registerCustomHook('onSuccessLoadingPage', (params) => {

        window.scrollTo(0,0);

        if (params.page.template === 'index') {
            params.page.headerStyle = 1;
        } else {
            params.page.headerStyle = 2;
        }

    });
	registerCustomHook('onSettingsLoaded', (params) => {

        window.addEventListener('scroll', () => {
            let heroBg = document.getElementById("heroImage");

            if (heroBg) {
                let st = window.scrollY;
                let limit = heroBg.offsetHeight;
                if (st <= limit) {
                    heroBg.style.transform = "translateY(" + ((st/(limit * 3)) * 100) + "%)";
                } else {
                }
            }


        });

    });
    //registerCustomHook('onComponentCookieAccept', (accepted) => {});
    //registerCustomHook('modifySearchSlug', (params) => { return true; });
};



